import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
import { Link } from 'react-router-dom';
import { motion, useReducedMotion } from 'framer-motion';
import { easeEnter, stagger, viewportOnce } from '../utils/motion';
export function CTA() {
  const reduceMotion = useReducedMotion();
  const item = (index: number) => ({
    initial: reduceMotion ? false as const : {
      opacity: 0,
      y: 14
    },
    whileInView: {
      opacity: 1,
      y: 0
    },
    viewport: viewportOnce,
    transition: {
      duration: 0.3,
      ease: easeEnter,
      delay: stagger(index, reduceMotion)
    }
  });
  return <section id="strategy" className="bg-ink px-5 py-24 text-paper md:px-10 md:py-32" aria-labelledby="cta-heading" data-id="element-319" data-mp="1gjj9y7jiflbo">
      <div className="mx-auto max-w-4xl text-center" data-id="element-320" data-mp="o1dwekwmm6xt">
        <motion.p {...item(0)} className="text-xs font-extrabold tracking-[0.16em] text-signal" data-id="element-321" data-mp="o02t0m73f178">
          BUILD THE NEXT CATEGORY OF ACTIVATION
        </motion.p>
        <motion.h2 id="cta-heading" {...item(1)} className="mt-5 font-display text-5xl font-bold leading-[0.88] md:text-7xl" data-id="element-322" data-mp="33dvdzdfiybdp">
          Your next activation should teach you something.
        </motion.h2>
        <motion.p {...item(2)} className="mx-auto mt-7 max-w-2xl text-lg leading-relaxed text-paper/70 md:text-xl" data-id="element-323" data-mp="3h5rzuzqlnp1n">
          Turn real product experiences into measurable media, stronger consumer
          relationships, and a smarter next decision.
        </motion.p>
        <motion.div {...item(3)} className="mt-10 flex flex-col justify-center gap-3 sm:flex-row" data-id="element-324" data-mp="2tg76dmwtl9e4">
          <Link to="/#start" className="inline-flex min-h-14 items-center justify-center gap-2 rounded-full bg-signal px-7 text-sm font-extrabold text-white transition-colors hover:bg-signal-dark active:bg-signal-darker" data-id="element-325" data-mp="2yfk1euxuhmrs">
            START A CAMPAIGN
            <ArrowRightIcon size={17} aria-hidden="true" data-id="element-326" data-mp="29robe12jlfjl" />
          </Link>
          <a href="#media-loop" className="inline-flex min-h-14 items-center justify-center rounded-full border border-paper/35 px-7 text-sm font-extrabold transition-colors hover:bg-paper hover:text-ink" data-id="element-327" data-mp="25qmbdi0swzgk">
            SEE THE MEDIA LOOP
          </a>
        </motion.div>
      </div>
    </section>;
}